import React, { memo, useCallback, useContext } from "react";
import { CustomGrid } from "../../../library/custom/CustomGrid/CustomGrid";
import { CustomButton } from "../../../library/custom/CustomButton/CustomButton";
import { CustomTypography } from "../../../library/custom/CustomTypography/CustomTypography";
import { CustomLink } from "../../../library/custom/CustomLink/CustomLink";
import { useStyles } from "./styles";
import { AppTargetPlatform } from "../../../contexts/DownloadContext/types";
import { DownloadContext } from "../../../contexts/DownloadContext/DownloadContext";
import { WindowsIcon } from "../../../library/icons/WindowsIcon";

const DownloadForWindows = memo(() => {
  const {
    actions: { onRequestDownload },
  } = useContext(DownloadContext);

  const classes = useStyles();

  const handleClickMacIntelDownload = useCallback(() => {
    onRequestDownload({ target: AppTargetPlatform.darwinX64 });
  }, []);

  const handleClickMacAppleDownload = useCallback(() => {
    onRequestDownload({ target: AppTargetPlatform.darwinArm64 });
  }, []);

  const handleClickWinDownload = useCallback(() => {
    onRequestDownload({ target: AppTargetPlatform.windowsX64 });
  }, []);

  return (
    <CustomGrid container direction="column" gap={6.75} alignItems="center">
      <CustomButton
        variant="contained"
        nameSpace="downloadingPage"
        translation="download.platforms.windows"
        startIcon={<WindowsIcon />}
        onClick={handleClickWinDownload}
        className={classes.button}
      />
      <CustomGrid item container width="fit-content">
        <CustomTypography
          whiteSpace="break-spaces"
          nameSpace="downloadingPage"
          translation="download.alsoAvailable"
        />
        <CustomLink color="primary">
          <CustomTypography
            nameSpace="downloadingPage"
            color="inherit"
            translation="download.platforms.macIntel"
            onClick={handleClickMacIntelDownload}
          />
        </CustomLink>
        <CustomTypography
          whiteSpace="break-spaces"
          nameSpace="downloadingPage"
          translation="download.and"
        />
        <CustomLink color="primary">
          <CustomTypography
            nameSpace="downloadingPage"
            color="inherit"
            translation="download.platforms.macApple"
            onClick={handleClickMacAppleDownload}
          />
        </CustomLink>
      </CustomGrid>
    </CustomGrid>
  );
});

export { DownloadForWindows };
